import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useEffect, useState } from 'react';
import LanguageContext from "../../context/LanguageContext";
import Link from "next/link";
import { getPersonalProfile } from "../../api/requests";
import { useRouter } from 'next/router';
import useTranslation from "next-translate/useTranslation";
var NavLogoWhite = "/images/logos/white.png";
var NavLogoBlue = "/images/logos/dark-blue.png";
var IranFlag = "/images/iran-flag-400.png";
var EnglishFlag = "/images/EnglishFlag.png";

var Navbar = function Navbar(_ref) {
  var image = _ref.image,
      rtl = _ref.rtl,
      handleToggleSidebar = _ref.handleToggleSidebar,
      toggled = _ref.toggled,
      collapsed = _ref.collapsed,
      classes = _ref.classes;
  var router = useRouter(); // if menuColor is false, its background color is blue, else it is blue

  var _useState = useState(true),
      menuColor = _useState[0],
      setMenuColor = _useState[1];

  var _useState2 = useState(null),
      user = _useState2[0],
      setUser = _useState2[1];

  var _useState3 = useState(null),
      Counter = _useState3[0],
      setCounter = _useState3[1];

  var _useState4 = useState(null),
      profImage = _useState4[0],
      setProfImage = _useState4[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';

  var _useContext = useContext(LanguageContext),
      language = _useContext.language,
      toggleLanguage = _useContext.toggleLanguage;

  var _useState5 = useState(''),
      homeFirstTimeUser = _useState5[0],
      setHomeFirstTimeUser = _useState5[1];

  var _useState6 = useState(''),
      userNameLang = _useState6[0],
      setUserNameLang = _useState6[1];

  useEffect(function () {
    var homeFirstTimeUserConst = localStorage.getItem('homeFirstTimeUser');
    console.log("homeFirstTimeUserConst", homeFirstTimeUserConst);

    if (homeFirstTimeUserConst !== '1') {
      setHomeFirstTimeUser(0);
      localStorage.setItem('homeFirstTimeUser', 0);
    } else if (homeFirstTimeUserConst == '1') {
      setHomeFirstTimeUser(1);
    }
  }, [homeFirstTimeUser]);

  var startClicked = function startClicked() {
    setHomeFirstTimeUser(1);
    localStorage.setItem('homeFirstTimeUser', 1);
  };

  var handleClickToggle = function handleClickToggle() {
    handleToggleSidebar(!toggled);
  };

  var getProfileImageSrc = function getProfileImageSrc(item) {
    if (item && item.ProfileImage && item.ProfileImage === 'img/head.png') {
      return '/images/table/profile.png';
    } else if (item && item.ProfileImage && item.ProfileImage !== " ") {
      return item.ProfileImage;
    } else {
      return '/images/table/profile.png';
    }
  };

  useEffect(function () {
    // const Username = localStorage.getItem('Username');
    // const counter = localStorage.getItem('Counter');
    // if (Username) {
    //     setUser(Username)
    // }
    // if (counter) {
    //     setCounter(counter)
    // }
    if (router.pathname == "/") {
      setMenuColor(false);
    }
  }, []); // console.log("Counter",Counter)

  useEffect(function () {
    var token = localStorage.getItem('token');
    var isLogin = localStorage.getItem('isLogin');
    var Username = localStorage.getItem('Username');
    var Counter = localStorage.getItem('Counter');

    if (Counter && Counter != 'undefined') {
      setCounter(Counter);
    }

    (Username === null || Username === void 0 ? void 0 : Username.length) > 2 && setUser(Username);

    if (token && isLogin === 'true') {
      getPersonalProfile(token).then(function (res) {
        var _res$data, _res$data2, _res$data3, _res$data4, _res$data5;

        // console.log("getPersonalProfile res:",res)
        (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.Counter) && setCounter(res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.Counter);
        (res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.FullName) && setUser(res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.FullName);
        var isEnglish = /^[A-Za-z\s]+$/;
        var testThis = isEnglish.test(res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.FullName);

        if (testThis) {
          setUserNameLang('en');
        } else {
          setUserNameLang('fa');
        }

        localStorage.setItem('Counter', res.data.Counter);
        localStorage.setItem('Username', res.data.FullName);
        var result = getProfileImageSrc(res.data);
        setProfImage(result);
      })["catch"](function (err) {
        return console.log(err);
      });
    }
  }, []);

  var getHref = function getHref() {
    var href = '';

    if (Object.keys(router.query).length > 0) {
      // console.log('aaa','in hereeeeeeeeee')
      href = {
        pathname: router.pathname,
        query: router.query
      };
    } else {
      // console.log('aaa','elseeeeeeeeeeee')
      href = {
        // pathname: '/blog/[post]/[comment]'
        pathname: router.pathname
      };
    }

    return href;
  };

  var getUserName = function getUserName() {
    if (window.innerWidth < 410) {
      return user.length > 10 ? user.slice(0, 8).concat('...') : user;
    } else {
      return user;
    }
  };

  return (
    /*#__PURE__*/
    // <nav className={`navbar navbar-expand-lg ${menuColor ? "bg-white" : "bg-blue"}`} style={{fontFamily:isRTL?'Yekan':'Helvetica'}}>
    _jsxs("nav", {
      className: "navbar navbar-expand-lg ".concat(menuColor ? "bg-white" : "bg-blue"),
      style: {
        fontFamily: isRTL ? 'Yekan' : 'Helvetica',
        direction: isRTL ? 'rtl' : 'ltr'
      },
      children: [homeFirstTimeUser == 0 && /*#__PURE__*/_jsx("div", {
        className: "toolTip ".concat(isRTL ? 'toolTipFa' : ''),
        children: /*#__PURE__*/_jsx("p", {
          className: "toolTipText ".concat(isRTL ? 'toolTipTextFa' : ''),
          style: {
            direction: isRTL ? 'rtl' : 'ltr'
          },
          children: t('navbar:You can start from here!')
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "container-fluid",
        children: [/*#__PURE__*/_jsx(Link, {
          href: "/",
          children: /*#__PURE__*/_jsx("a", {
            className: "navbar-brand",
            children: /*#__PURE__*/_jsx("img", {
              className: "nav-logo",
              src: menuColor ? NavLogoBlue : NavLogoWhite
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "d-flex",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "right - items mobileOnly ".concat(menuColor ? "logButtonsBg" : ""),
            children: [!user && /*#__PURE__*/_jsxs("div", {
              className: "d-flex navLog",
              children: [/*#__PURE__*/_jsx(Link, {
                href: {
                  pathname: '/verifyPhone',
                  query: {
                    redirect: 'home'
                  }
                },
                children: /*#__PURE__*/_jsx("a", {
                  className: "p-1 weight400 darkBlue marginLeft linkStyleWhite logLink ".concat(menuColor ? "text-blue" : "text-white"),
                  children: t('navbar:register')
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "m-1  text-white separator ".concat(menuColor ? "separator" : "separatorBlue")
              }), /*#__PURE__*/_jsx(Link, {
                href: {
                  pathname: '/verifyPhone',
                  query: {
                    redirect: 'home'
                  }
                },
                children: /*#__PURE__*/_jsx("a", {
                  className: "p-1 weight400 darkBlue marginRight linkStyleWhite logLink ".concat(menuColor ? "text-blue" : "text-white"),
                  children: t('navbar:login')
                })
              })]
            }), user && Counter && /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsx(Link // href="/profile"
              , {
                href: {
                  pathname: "/profile/".concat(Counter),
                  query: {
                    name: user
                  }
                },
                children: /*#__PURE__*/_jsxs("a", {
                  className: "d-flex linkStyle p-1 align-items-center",
                  children: [/*#__PURE__*/_jsx("div", {
                    className: "".concat(isRTL ? "pl-2" : "pr-2", " userName weight500 ").concat(menuColor ? "text-blue" : "text-white"),
                    style: {
                      direction: userNameLang === 'en' ? 'ltr' : 'rtl'
                    },
                    children: getUserName()
                  }), /*#__PURE__*/_jsx("div", {
                    className: "userAvatar ",
                    children: profImage ? /*#__PURE__*/_jsx("img", {
                      src: profImage,
                      alt: "avatar"
                    }) : /*#__PURE__*/_jsx("img", {
                      src: "/images/table/profile.png",
                      alt: "avatar"
                    })
                  })]
                })
              })
            })]
          }), /*#__PURE__*/_jsx(Link, {
            href: getHref(),
            locale: isRTL ? "en" : "farsi",
            children: /*#__PURE__*/_jsx("a", {
              className: "".concat(isRTL ? 'pr-2' : 'pl-2', " langBox linkStyle mobileOnly"),
              children: /*#__PURE__*/_jsxs("div", {
                className: "langBox d-flex ",
                onClick: toggleLanguage,
                children: [/*#__PURE__*/_jsx("div", {
                  style: {
                    fontFamily: isRTL ? 'Helvetica' : 'Yekan'
                  },
                  className: "userName weight500 ".concat(menuColor ? "text-blue" : "text-white"),
                  children: isRTL ? "English" : "فارسی"
                }), /*#__PURE__*/_jsx("img", {
                  className: "flag",
                  src: isRTL ? EnglishFlag : IranFlag,
                  alt: ""
                })]
              })
            })
          }), /*#__PURE__*/_jsx("button", {
            onClick: handleClickToggle,
            className: "navbar-toggler",
            type: "button",
            "data-bs-toggle": "collapse",
            "data-bs-target": "#navbarSupportedContent",
            "aria-controls": "navbarSupportedContent",
            "aria-expanded": "false",
            "aria-label": "Toggle navigation",
            children: /*#__PURE__*/_jsx("span", {
              className: "",
              children: /*#__PURE__*/_jsx("img", {
                className: "burger",
                src: menuColor ? "/images/sidebar/blue-toggler.svg" : "/images/sidebar/white-burger.png",
                alt: ""
              })
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "collapse navbar-collapse",
          id: "navbarSupportedContent",
          children: [/*#__PURE__*/_jsxs("ul", {
            className: "navbar-nav ".concat(isRTL ? "ml-auto pr-0" : "mr-auto"),
            children: [/*#__PURE__*/_jsx("li", {
              className: "nav-item",
              children: /*#__PURE__*/_jsx(Link, {
                "aria-current": "page",
                href: "/",
                children: /*#__PURE__*/_jsx("a", {
                  className: "nav-link ".concat(menuColor ? "text-blue" : "text-white whiteNav"),
                  "data-content": isRTL ? "خانه" : "Home",
                  children: t('navbar:home')
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              className: "nav-item start",
              onClick: function onClick() {
                return startClicked();
              },
              children: /*#__PURE__*/_jsx(Link, {
                "aria-current": "page",
                href: "/start",
                children: /*#__PURE__*/_jsx("a", {
                  className: "nav-link ".concat(menuColor ? "text-blue" : "text-white whiteNav"),
                  "data-content": isRTL ? "شروع" : "Start",
                  children: t('navbar:start')
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              className: "nav-item",
              onClick: function onClick() {
                return startClicked();
              },
              children: /*#__PURE__*/_jsx(Link, {
                href: "/learn",
                children: /*#__PURE__*/_jsx("a", {
                  className: "nav-link ".concat(menuColor ? "text-blue" : "text-white whiteNav"),
                  "data-content": isRTL ? "تمرین" : "Learn",
                  children: t('navbar:learn')
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              className: "nav-item",
              children: /*#__PURE__*/_jsx(Link, {
                href: "/wow-stories",
                children: /*#__PURE__*/_jsx("a", {
                  className: "nav-link ".concat(menuColor ? "text-blue" : "text-white whiteNav"),
                  "data-content": isRTL ? "داستان‌ ها" : "WoW Stories",
                  children: t('navbar:wowStories')
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              className: "nav-item",
              children: /*#__PURE__*/_jsx("a", {
                className: "nav-link ".concat(menuColor ? "text-blue" : "text-white whiteNav"),
                "data-content": isRTL ? "مجله" : "WoW Magazine",
                href: "https://wowmagazine.ir/",
                target: "_blank",
                children: t('navbar:wowMagazine')
              })
            }), /*#__PURE__*/_jsx("li", {
              className: "nav-item",
              children: /*#__PURE__*/_jsx(Link, {
                href: "/top-users",
                children: /*#__PURE__*/_jsx("a", {
                  className: "nav-link ".concat(menuColor ? "text-blue" : "text-white whiteNav"),
                  "data-content": isRTL ? "کاربران برتر" : "Top Users",
                  children: t('navbar:topUsers')
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              className: "nav-item",
              children: /*#__PURE__*/_jsx(Link, {
                href: "/about-us",
                children: /*#__PURE__*/_jsx("a", {
                  className: "nav-link ".concat(menuColor ? "text-blue" : "text-white whiteNav"),
                  "data-content": isRTL ? "درباره ما" : "About Us",
                  children: t('navbar:aboutUs')
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              className: "nav-item",
              children: /*#__PURE__*/_jsx(Link, {
                href: "/score",
                children: /*#__PURE__*/_jsx("a", {
                  className: "nav-link ".concat(menuColor ? "text-blue" : "text-white whiteNav"),
                  "data-content": isRTL ? "قوانین" : "Rules",
                  children: t('navbar:rules')
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              className: "nav-item",
              children: /*#__PURE__*/_jsx(Link, {
                href: "/contact-us",
                children: /*#__PURE__*/_jsx("a", {
                  className: "nav-link ".concat(menuColor ? "text-blue" : "text-white whiteNav"),
                  "data-content": isRTL ? "تماس با ما" : "Contact Us",
                  children: t('navbar:contactUs')
                })
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "right - items d-flex ".concat(menuColor ? "logButtonsBg" : ""),
            children: [!user && /*#__PURE__*/_jsxs("div", {
              className: "d-flex navLog",
              children: [/*#__PURE__*/_jsx(Link, {
                href: {
                  pathname: '/verifyPhone',
                  query: {
                    redirect: 'home'
                  }
                },
                children: /*#__PURE__*/_jsx("a", {
                  className: "p-1 weight400 darkBlue marginLeft linkStyleWhite logLink ".concat(menuColor ? "text-blue" : "text-white"),
                  children: t('navbar:register')
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "m-1  text-white separator"
              }), /*#__PURE__*/_jsx(Link, {
                href: {
                  pathname: '/verifyPhone',
                  query: {
                    redirect: 'home'
                  }
                },
                children: /*#__PURE__*/_jsx("a", {
                  className: "p-1 weight400 darkBlue marginRight linkStyleWhite logLink ".concat(menuColor ? "text-blue" : "text-white"),
                  children: t('navbar:login')
                })
              })]
            }), user && Counter && /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsx(Link // href="/profile"
              , {
                href: {
                  pathname: "/profile/".concat(Counter),
                  query: {
                    name: user
                  }
                },
                children: /*#__PURE__*/_jsxs("a", {
                  className: "d-flex linkStyle p-1 align-items-center",
                  children: [/*#__PURE__*/_jsx("div", {
                    className: "".concat(isRTL ? "pl-2" : "pr-2", " userName weight500 ").concat(menuColor ? "text-blue" : "text-white"),
                    children: user
                  }), /*#__PURE__*/_jsx("div", {
                    className: "userAvatar ",
                    children: profImage ? /*#__PURE__*/_jsx("img", {
                      src: profImage,
                      alt: "avatar"
                    }) : /*#__PURE__*/_jsx("img", {
                      src: "/images/table/profile.png",
                      alt: "avatar"
                    })
                  })]
                })
              })
            })]
          }), /*#__PURE__*/_jsx(Link, {
            href: getHref(),
            locale: isRTL ? "en" : "farsi",
            children: /*#__PURE__*/_jsx("a", {
              className: "".concat(isRTL ? 'pr-2' : 'pl-2', " langBox d-flex linkStyle"),
              children: /*#__PURE__*/_jsxs("div", {
                className: "langBox d-flex ",
                onClick: toggleLanguage,
                children: [/*#__PURE__*/_jsx("div", {
                  style: {
                    fontFamily: isRTL ? 'Helvetica' : 'Yekan'
                  },
                  className: "userName weight500 ".concat(menuColor ? "text-blue" : "text-white"),
                  children: isRTL ? "English" : "فارسی"
                }), /*#__PURE__*/_jsx("img", {
                  className: "flag",
                  src: isRTL ? EnglishFlag : IranFlag,
                  alt: ""
                })]
              })
            })
          })]
        })]
      })]
    })
  );
};

export default Navbar;